import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import BrakingDistanceCalculator from '../components/tools/BrakingDistanceCalculator';

const BrakingDistanceCalculatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="braking-distance-calculator-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="Braking Distance Calculator"
        description="Estimate reaction, braking, and total stopping distance from vehicle mass, speed, road friction, and gradient, with an Advanced mode covering dynamic weight transfer and brake-system-torque limits. Regenerative braking is out of scope."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="braking-distance-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <BrakingDistanceCalculator />
          <ToolGuideCta guidePath="/tools/braking-distance-calculator/guide" toolName="Braking Distance Calculator" />
        </div>
      </section>
    </div>
  );
};

export default BrakingDistanceCalculatorPage;
